import React, { useState, useEffect, useRef } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import GridContainer from 'components/Grid/GridContainer';
import { wsGet, wsFindBy } from 'services/WService';
import GridItem from 'components/Grid/GridItem';
import { Search } from '@material-ui/icons';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 50 },

  { Header: 'Codigo Producto', accessor: 'CodigoProducto', width: 150 },
  { Header: 'Nombre Producto', accessor: 'NombreProducto' },
  { Header: 'Almacen', accessor: 'Almacen', width: 150 },
  { Header: 'Stock Fisico', accessor: 'StockFisico', width: 120 },
  { Header: 'Stock Comprometido', accessor: 'StockComprometido', width: 180 },
  { Header: 'Stock Disponible', accessor: 'StockDisponible', width: 150 },

  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function AvailableStock() {
  const [stocks, setStocks] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const warehouseRef = useRef();
  const itemCodeRef = useRef();
  const itemNameRef = useRef();
  const [dataLoading, setDataLoading] = useState(false);

  async function getWarehouses() {
    setDataLoading(true);
    let res = await wsGet('logi/warehouse?warehouse_type=N');
    setDataLoading(false);
    if(res.success){
      setWarehouses(res.data);
    }
  }

  useEffect(() => {
    getWarehouses();
    wsGet('logi/available-stock').then((res) => {
      setStocks(res.data);
    });
  }, []);

  async function loadStock() {
    let data = {
      WhsCode: warehouseRef.current.value,
      ItemCode: itemCodeRef.current.value,
      ItemName: itemNameRef.current.value,
    };

    let res = await wsFindBy('logi/available-stock', data);
    if (res.success) {
      setStocks(res.data);
    }
  }

  return (
    <CardContainer /*title="Consulta de stock disponible"*/ title={(<>Consulta de stock disponible {dataLoading && <LoadingSpinner />}</>)}>
      
      {/* Filtros */}
      <GridContainer>
        <GridItem xs={4} lg={3} xl={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Almacén</InputLabel>
            <Select inputRef={warehouseRef}>
              {warehouses.map((warehouse) => {
                return (
                  <MenuItem key={warehouse.id} value={warehouse.WhsCode}>
                    {warehouse.WhsName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={4} lg={3} xl={2}>
          <TextField label="Código" fullWidth inputRef={itemCodeRef} />
        </GridItem>
        <GridItem xs={4} lg={3} xl={2}>
          <TextField label="Nombre" fullWidth inputRef={itemNameRef} />
        </GridItem>
        <GridItem xs={4} lg={3} xl={2}>
          <RegularButton justIcon round color="success" onClick={loadStock}>
            <Search />
          </RegularButton>
        </GridItem>
      </GridContainer>
      
      <ReactTable
        columns={columns}
        data={stocks.map((item, i) => {
          return {
            ...item,
            num: i + 1,
            StockFisico: parseInt(item.StockFisico),
            StockComprometido: parseInt(item.StockComprometido),
            StockDisponible: parseInt(item.StockDisponible),
          };
        })}
      />
    </CardContainer>
  );
}

export default AvailableStock;
